import { CLIENTES_ANALISES_MERCADOS_API_RESOURCE } from '../consts';

/** Resource da API das revisões das Análises de Mercado */
export const CLIENTES_ANALISES_MERCADOS_REVISOES_API_RESOURCE = `${CLIENTES_ANALISES_MERCADOS_API_RESOURCE}/revisoes`;
